<template lang="pug">
.container-register
  .register
    .header-register
      img(class="logo" src="@/assets/logo.webp" alt="Marca da empresa Nexa Skills" class="logo")
      h2 Boas-Vindas a Nexa <strong className="text-nexa_lime">_</strong>
      p Faça seu cadastro e descubra todas as vantagens de ser um <strong>Nexa</strong> User!
    .register-form
      EffectInput(
        v-model="nome"
        type="text"
        placeholder="Nexano User"
        label="Nome Completo"
      )
      EffectInput(
        v-model="email"
        type="email"
        placeholder="nexanouserm@nexa.com"
        label="Email"
      )
      .email-error(v-if="emailError")
        p {{ emailError }}
      EffectInput(
        v-model="usuario"
        type="text"
        placeholder="Seu apelido (será exibido no perfil)"
        label="Usuário"
      )
      .password-field
        EffectInput(
          v-model="senha"
          :type="showPassword ? 'text' : 'password'"
          placeholder="Digite sua senha"
          label="Senha"
        )
        .password-toggle(@click="togglePasswordVisibility")
          LucideIcon(:name="showPassword ? 'EyeOff' : 'Eye'" :size="16")
      
      .password-requirements
        .requirement(:class="{ valid: senhaTemMinimo8Caracteres }")
          span.check ✓
          span.text Mínimo 8 caracteres
        .requirement(:class="{ valid: senhaTemMaiuscula }")
          span.check ✓
          span.text Pelo menos uma letra maiúscula
        .requirement(:class="{ valid: senhaTemMinuscula }")
          span.check ✓
          span.text Pelo menos uma letra minúscula
        .requirement(:class="{ valid: senhaTemNumero }")
          span.check ✓
          span.text Pelo menos um número
        .requirement(:class="{ valid: senhaTemCaractereEspecial }")
          span.check ✓
          span.text Pelo menos um caractere especial (!@#$%...)
      
      .password-field
        EffectInput(
          v-model="confirmaSenha"
          :type="showConfirmPassword ? 'text' : 'password'"
          placeholder="Confirme sua senha"
          label="Confirmar Senha"
        )
        .password-toggle(@click="toggleConfirmPasswordVisibility")
          LucideIcon(:name="showConfirmPassword ? 'EyeOff' : 'Eye'" :size="16")
        
      .password-error(v-if="passwordError")
        p {{ passwordError }}
      div
        Button(
          variant="borderless"
          width="100%"
          class="btn-gradient-hover"
          :class="[ !isFormValid && 'disabled' ]"
          :disabled="!isFormValid"
          @click="handleRegister"
        ) 
          template(v-if="isLoading") Registrando...
          template(v-else)
            | Ser Nexa 
            img.img-right(src="@/assets/icons/arrow_right.svg")
        BottomGradient
      div
        BorderGradient
    .vem-ser-nexa
      h2 Já é um Nexa User? 
        Link(
          href="/login"
          color="$corPrimary"
          :underline="true"
          text="Entre aqui"
        )

</template>

<script>
import { mapGetters } from 'vuex'
import EffectInput from '@/components/ui/EffectInput.vue'
import Button from '@/components/ui/Button.vue'
import BottomGradient from '@/components/ui/BottomGradient.vue'
import BorderGradient from '@/components/ui/BorderGradient.vue'
import Link from '@/components/ui/Link.vue'

export default {
  components: {
    EffectInput,
    Button,
    BottomGradient,
    BorderGradient,
    Link,
  },

  data() {
    return {
      usuario: '',
      nome: '',
      email: '',
      senha: '',
      confirmaSenha: '',
      showPassword: false,
      showConfirmPassword: false
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'auth/isLoading',
      authError: 'auth/getError'
    }),

    senhaTemMinimo8Caracteres() {
      return this.senha && this.senha.length >= 8
    },
    
    senhaTemMaiuscula() {
      return this.senha && /[A-Z]/.test(this.senha)
    },
    
    senhaTemMinuscula() {
      return this.senha && /[a-z]/.test(this.senha)
    },
    
    senhaTemNumero() {
      return this.senha && /[0-9]/.test(this.senha)
    },
    
    senhaTemCaractereEspecial() {
      return this.senha && /[!@#$%^&*(),.?":{}|<>_\-+=\[\]\\;'/`~]/.test(this.senha)
    },
    
    senhaValida() {
      return this.senhaTemMinimo8Caracteres &&
             this.senhaTemMaiuscula &&
             this.senhaTemMinuscula &&
             this.senhaTemNumero &&
             this.senhaTemCaractereEspecial
    },

    passwordError() {
      if (!this.confirmaSenha) return null
      
      if (this.senha !== this.confirmaSenha) {
        return 'As senhas não conferem'
      }
      return null
    },

    emailError() {
      if (!this.email) return null
      
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.email)) {
        return 'Digite um email válido'
      }
      return null
    },

    isFormValid() {
      return (
        this.usuario.trim() !== '' &&
        this.nome.trim() !== '' &&
        this.email.trim() !== '' &&
        this.emailError === null &&
        this.senha.trim() !== '' &&
        this.senhaValida &&
        this.confirmaSenha.trim() !== '' &&
        this.senha === this.confirmaSenha &&
        !this.isLoading
      )
    }
  },

  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
    
    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword
    },

    async handleRegister() {
      // Validação antes de enviar
      if (!this.isFormValid) {
        this.$message({
          message: 'Por favor, preencha todos os campos corretamente',
          type: 'warning'
        })
        return
      }

      try {
        // Dados para o endpoint
        const userData = {
          usuario: this.usuario,
          nome: this.nome,
          email: this.email,
          senha: this.senha,
          confirmacao_senha: this.confirmaSenha
        }

        // Chama a action de registro
        const result = await this.$store.dispatch('auth/register', userData)

        if (result.success) {
          this.$message({
            message: 'Cadastro realizado com sucesso!',
            type: 'success'
          })
          
          // Redireciona para login após sucesso
          setTimeout(() => {
            this.$router.push('/login')
          }, 1500)
        } else {
          this.$message({
            message: result.error || 'Erro ao realizar cadastro',
            type: 'error'
          })
        }
      } catch (error) {
        this.$message({
          message: 'Erro inesperado ao realizar cadastro',
          type: 'error'
        })
        console.error('Erro no registro:', error)
      }
    }
  }
}
</script>

<style lang="scss">
.container-register{
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  box-sizing: border-box;
  overflow-y: auto;

  .register{
    width: 450px;
    max-width: 100%;
    background: $corPreto;
    border-radius: 16px;
    padding: 32px;
    box-sizing: border-box;
    color: $corBranco;

    .header-register{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      
      img.logo{
        width: 290px;
        margin-bottom: 32px;
      }
    }

    h2{
      display: block;
      width: 100%;
      font-size: 20px;
      margin: 0 0 12px 0;
      padding: 0;
      text-align: left;
      color: $corCinzaClaro;

      strong{
        margin-left: -10px;
        color: $corPrimary;
      }
    }
    p{
      width: 100%;
      font-size: 14px;
      margin: 0;
      padding: 0;
      text-align: left;
      line-height: 18px;
      color: $corCinzaEscuro;
    }

    .register-form{
      width: 100%;
      margin: 32px 0;

      .email-error {
        margin-top: -16px;
        margin-bottom: 16px;
        
        p {
          color: #ef4444;
          font-size: 12px;
          margin: 0;
          padding: 0;
          text-align: left;
          line-height: 14px;
        }
      }

      .password-field {
        position: relative;
        margin-bottom: 20px;

        .password-toggle {
          position: absolute;
          right: 12px;
          top: 47%;
          cursor: pointer;
          color: #a3a3a3;
          transition: color 0.2s ease;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;

          &:hover {
            color: $corPrimary;
          }
        }

        span {
          margin-bottom: 0;
        }
      }

      .password-error {
        margin-top: -16px;
        margin-bottom: 16px;
        
        p {
          color: #ef4444;
          font-size: 12px;
          margin: 0;
          padding: 0;
          text-align: left;
          line-height: 14px;
        }
      }

      .password-requirements {
        margin-top: -12px;
        margin-bottom: 16px;
        padding: 12px;
        background: rgba(255, 255, 255, 0.02);
        border-radius: 8px;
        border: 1px solid rgba(255, 255, 255, 0.05);
        
        .requirement {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 6px;
          transition: all 0.2s ease;
          
          &:last-child {
            margin-bottom: 0;
          }
          
          .check {
            font-size: 14px;
            color: #4b5563;
            font-weight: bold;
            transition: color 0.2s ease;
          }
          
          .text {
            font-size: 12px;
            color: #6b7280;
            line-height: 14px;
            transition: color 0.2s ease;
          }
          
          &.valid {
            .check {
              color: $corPrimary;
            }
            
            .text {
              color: $corPrimary;
            }
          }
        }
      }

      .btn-gradient-hover.disabled {
        opacity: 0.4 !important;
        cursor: not-allowed !important;
        
        &:hover {
          opacity: 0.4 !important;
        }
        
        // Mantém o estilo original do botão
        background: transparent !important;
        border: none !important;
      }
    }
    .vem-ser-nexa{
      width: 100%;
      text-align: left;
      h2{
        color: $corBrancoClaro;
        font-size: 16px;
        margin-bottom: 0;
        font-weight: 500;
      }
    }

    @media screen and (max-width: 414px) {
      width: 100%;
      padding: 10px;
      margin: 10px 0;

      .header-register{
        img.logo{
          width: 150px;
          margin-bottom: 12px;
        }
      }
      
      h2{
        font-size: 16px;
        margin-bottom: 6px;
      }
      
      p{
        font-size: 12px;
        line-height: 15px;
      }
      
      .register-form{
        margin: 10px 0;

        .linha{
          margin: 12px 0;
        }
        
        .password-requirements {
          padding: 8px;
          margin-top: -10px;
          margin-bottom: 12px;
          
          .requirement {
            margin-bottom: 4px;
            
            .check {
              font-size: 12px;
            }
            
            .text {
              font-size: 11px;
              line-height: 13px;
            }
          }
        }
      }

      .vem-ser-nexa{
        h2{
          font-size: 12px;
          
          .vue-link{
            font-size: 12px !important;
          }
        }
      }
    }

    @media screen and (max-width: 400px) {
      width: 100%;
      padding: 10px;
      margin: 10px 0;

      .header-register{
        img.logo{
          width: 140px;
          margin-bottom: 12px;
        }
      }
      h2{
        font-size: 15px;
        margin-bottom: 6px;
      }
      .register-form{
        margin: 10px 0;

        .linha{
          margin: 12px 0;
        }
      }

      .vem-ser-nexa{
        h2{
          font-size: 12px;
          
          .vue-link{
            font-size: 12px !important;
          }
        }
      }
    }

  }
  
  @media screen and (max-width: 600px) {
    background: $corPreto;
    min-height: 100vh;
    height: auto;
    padding: 20px 12px;
    align-items: flex-start;

    .register{
      width: 100%;
      height: auto;
      padding: 16px;
      margin: 20px 0;

      .header-register{
        img.logo{
          width: 200px;
        }
      }
  
      h2{
        font-size: 18px;
        margin-bottom: 10px;
      }
  
      .vem-ser-nexa{
        h2{
          font-size: 14px;
          
          .vue-link{
            font-size: 14px !important;
          }
        }
      }
    }
  }
}
</style>